import { createGlobalStyle } from "styled-components";


const Typography = createGlobalStyle`
    /* Typography */

    * {
        box-sizing: border-box;
        -webkit-appearance: none;
        outline: none;
    }

    * {
        -webkit-font-smoothing: antialiased;
    }

    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration {
        -webkit-appearance: none;
    }

    input:-internal-autofill-selected {
        /* background-color: transparent !important; */
        /* box-shadow: inset 1000px 1000px #fff; */
    }

    input:focus::placeholder {
        color: transparent;
    }

    input {
        outline: none;
    }

    /* Change autocomplete styles in WebKit */
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
        /* border: 2px solid var(--white); */
        -webkit-text-fill-color: var(--black);
        color: var(--black);
        background-color: transparent;
        -webkit-box-shadow: 0 0 0 1000px transparent inset;
        transition: background-color 5000s ease-in-out 0s;
    }

    /* Change the white to any color ;) */
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 30px transparent inset !important;
    }

    @-webkit-keyframes autofill {
        to {
            background: transparent;
        }
    }

    ::-webkit-scrollbar {
        display: none;
    }


    a {
        text-decoration: none;
        color: inherit;
    }

    //Text capitalize

    .uppercase {
        text-transform: uppercase;
    }

    .capitalize {
        text-transform: capitalize;
    }

    .underline {
        text-decoration: underline;
    }

    .lineThrough{
        text-decoration: line-through;
    }

    //!Fonts

    .NewYork {
        font-family: NewYork;
    }

    .PopReg {
        font-family: PopReg;
    }

    .PopSemi {
        font-family: PopSemi;
    }

    //Cursor
    .cursorPointer {
        cursor:pointer;
    }

    .h1,
    h1 {
        font-size: var(--h1);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeightXS);
    }

    .h2,
    h2 {
        font-size: var(--h2);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeightS);
    }

    .h3,
    h3 {
        font-size: var(--h3);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeight);
    }

    .h4,
    h4 {
        font-size: var(--h4);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeigh);
    }

    .h5,
    h5 {
        font-size: var(--h5);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeight);
    }

    .h6,
    h6 {
        font-size: var(--h6);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeight);
    }

    .h7 {
        font-size: var(--h7);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeight);
    }
    .h8 {
        font-size: var(--h8);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeight);
    }

    .h9 {
        font-size: var(--h9);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeight);
    }

    .h10 {
        font-size: var(--h10);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeight);
    }
    
    .h11 {
        font-size: var(--h11);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeight);
    }

    .h12 {
        font-size: var(--h12);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeight);
    }
    .h13 {
        font-size: var(--h13);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeight);
    }

    .const14 {
        font-size: var(--const14);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeight);
    }
    p,
    .p,
    pre {
        font-size: var(--p);
        margin: 0;
        font-weight: unset;
        line-height: var(--lineHeight);
    }

    //! Tooltip

    .ant-tooltip {
        font-family: PopReg;
        font-size: var(--h8);
        color:var(--white);

        .ant-tooltip-inner {
            background-color: var(--black);
            border-radius: 12px;
        }
    }

    //! To top

    .toTop {
        position: fixed !important;
        bottom:100px;
        right:var(--containerPadding);
        width:60px;
        height: 60px;
        opacity: 0;
        pointer-events:none;
        transition:0.3s;    
        z-index:55;    

        &.active {
            pointer-events:all;
            opacity: 0.4;
            
            &:hover {
                opacity: 1;
            }
        }
    }
`

export default Typography